import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';

import { machineMigrationOpportunityPath } from './machineMigrationOpportunityPath';

export type MachineMigrationOpportunity = {
  migrationDate: string;
  triggeredWorkflows: {
    triggeredWorkflow: string;
    categoryType: 'machine_cost_saving';
    currentMachineType: string;
    suggestedMachineType: string;
    estimatedMonthlyCostChange: number;
    status: 'auto_enabled' | 'opted_in' | 'opted_out' | null;
    statusChangedAt: string | null;
    evidenceResource: 'cpu' | 'memory';
  }[];
};

type Response = { machineMigrationOpportunity: MachineMigrationOpportunity | null };

export const machineMigrationOpportunityQueryKey = (appSlug: string) =>
  ['apps', appSlug, 'machine_migration_opportunity'] as const;

const useMachineMigrationOpportunitiesShow = (
  appSlug: string,
  opts?: UseMonolithApiQueryOptions<Response, unknown>,
) => {
  const { data, ...rest } = useMonolithApiQuery<Response, unknown>(
    machineMigrationOpportunityQueryKey(appSlug),
    machineMigrationOpportunityPath(appSlug),
    opts,
  );

  return { data: data?.machineMigrationOpportunity, ...rest };
};

export default useMachineMigrationOpportunitiesShow;
